import styled from 'styled-components';
import { TradeState } from '../../../../../_shared/types/trade';
import Box from '../../../../../_shared/components/Box';

export const StyledContent = styled.div`
  height: ${({ tradeState }) => (tradeState === TradeState.active ? 72 : 41)}px;
  border-bottom: 2px solid ${({ theme }) => theme.COLORS.NEUTRAL_50};
`;

export const StyledContentHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StyledDistance = styled.div`
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  padding: 12px;
  max-width: 160px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const StyledControls = styled(Box)`
  display: flex;
  flex: 0 0 auto;
`;

export const StyledFloorMeterBadges = styled.div`
  padding-left: 6px;
`;
